<script setup lang="ts">
/**
 * Toutes les boutiques d'une association — page publique « tout lister », partageable telle quelle.
 * Voir `AssoListeFeature` pour le pourquoi.
 */
const slug = (useRoute().params as { slug: string }).slug;
const { t } = useI18n();
</script>

<template>
  <AssoListeFeature
    :slug="slug"
    domaine="shops"
    :titre="t('association.listeBoutiques.titre')"
    :sous-titre="t('association.listeBoutiques.sousTitre')"
    :message-vide="t('association.listeBoutiques.messageVide')"
  />
</template>
